/** @format */

import axios from 'axios'

const instance = axios.create({
	//baseURL: `${process.env.REACT_APP_API_URL}`,
	headers: {
		'Content-Type': 'application/json',
		'vlr-authorization': `${btoa(JSON.stringify({ id: process.env.REACT_APP_ID }))}`
	}
})

const cleanApiUrl = `${process.env.REACT_APP_API_URL}`.replace(/\/+$/, '')

const appsVersionApis = [
	{ sort: 10, key: 'app_pipedata_front', name: 'PipeData Front', url: '/version.json' },
	{ sort: 20, key: 'app_pipedata_back', name: 'PipeData Back', url: `${cleanApiUrl}/version` }
]

const getVersionNumber = (token, key) => {
	return new Promise((resolve, reject) => {
		const app = appsVersionApis.find(app => app.key === key)
		if (!app) {
			return reject(new Error(`Unknown app key: ${key}`))
		}

		instance
			.get(app.url, {
				headers: {
					Authorization: `${token}`
				}
			})
			.then(response => {
				if (response.status === 200 || response.status === 204) {
					resolve(response.data?.body ? response.data.body : response.data)
				} else {
					console.error(`Error fetching ${app.name} version`)
					resolve({ version: '0.0.0' })
				}
			})
			.catch(err => {
				console.error(`Error fetching ${app.name} version`, err)
				resolve({ version: '0.0.0' })
			})
	})
}

export default {
	getVersionNumbers: async token => {
		const versionData = []

		await Promise.all(
			appsVersionApis.map(async app => {
				console.log(`Fetching version for ${app.name}`)
				const data = await getVersionNumber(token, app.key)
				versionData.push({ name: app.name, key: app.key, version: data.version, sort: app.sort })
			})
		)
		return versionData.sort((a, b) => a.sort - b.sort)
	}
}
